import React from 'react';
interface VoxieLogoProps {
  className?: string;
}
const VoxieLogo: React.FC<VoxieLogoProps> = ({
  className = 'h-8 w-8'
}) => {
  return <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jk17enneRxZr5ro3znyzv1/ChatGPT_Image_Aug_12%2C_2025%2C_10_00_06_AM.png" alt="Voxie Logo" className={className} data-id="element-616" />;
};
export default VoxieLogo;